import { RouteRecordRaw } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';

const uiLibraryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/UiLibrary',
    name: 'UI Library',
    redirect: '/UiLibrary/Index',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/components/uiLibrary/UiLibraryLayout.vue'),
    meta: { layout: layoutAreaTypes.User },
    children: [
      {
        path: 'Index',
        name: 'UiLibraryIndex',
        meta: { showComponentPreview: false },
        redirect: 'UiLibrary/Buttons',
      },
      {
        path: '3DViewer',
        name: '3D Viewer',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibrary3DViewerPage.vue'),
      },
      {
        path: 'Alert',
        name: 'Alert',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryAlertPage.vue'),
      },
      {
        path: 'Avatar',
        name: 'Avatar',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryAvatarPage.vue'),
      },
      {
        path: 'Buttons',
        name: 'Buttons',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryButtonsPage.vue'),
      },
      {
        path: 'CardUser',
        name: 'Card User',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryCardUserPage.vue'),
      },
      {
        path: 'Chips',
        name: 'Chips',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryChipsPage.vue'),
      },
      {
        path: 'Checkboxes',
        name: 'Checkboxes',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryCheckboxesPage.vue'),
      },
      {
        path: 'Colors',
        name: 'Colors',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryColorsPage.vue'),
      },
      {
        path: 'Dropdowns',
        name: 'Dropdowns',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDropdownPage.vue'),
      },
      {
        path: 'DropdownsGrouped',
        name: 'Dropdowns Grouped',
        meta: { showComponentPreview: true },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDropdownGroupedPage.vue'
          ),
      },
      {
        path: 'DepartmentTree',
        name: 'Department Tree',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDepartmentPage.vue'),
      },
      {
        path: 'DatePicker',
        name: 'DatePicker',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDatePickerPage.vue'),
      },
      {
        path: 'DateRangePicker',
        name: 'DateRangePicker',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDateRangePickerPage.vue'
          ),
      },
      {
        path: 'DateTimePicker',
        name: 'DateTimePicker',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryDateTimePickerPage.vue'
          ),
      },
      {
        path: 'Editor',
        name: 'Editor',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryEditorPage.vue'),
      },
      {
        path: 'FormFields',
        name: 'Form Fields',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryFormFieldsPage.vue'),
      },
      {
        path: 'FilePicker',
        name: 'FilePicker',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryFilePickerPage.vue'),
      },
      {
        path: 'GridMvp',
        name: 'Grid Mvp',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/gridMvp/UiLibraryGridMvpPage.vue'
          ),
      },
      {
        path: 'Icons',
        name: 'Icons',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryIconsPage.vue'),
      },
      {
        path: 'Label',
        name: 'Label',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryLabelPage.vue'),
      },
      {
        path: 'Notifications',
        name: 'Notifications',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryNotificationsPage.vue'),
      },
      {
        path: 'PeoplePicker',
        name: 'PeoplePicker',
        meta: { showComponentPreview: false, isSingleComponent: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryPeoplePickerPage.vue'),
      },
      {
        path: 'RadioButtons',
        name: 'Radio Buttons',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryRadioButtonsPage.vue'),
      },
      {
        path: 'RadioButtonGroups',
        name: 'Radio Button Groups',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryRadioButtonGroupsPage.vue'
          ),
      },
      {
        path: 'RadioButtonCards',
        name: 'Radio Button Cards',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryRadioButtonCardsPage.vue'
          ),
      },
      {
        path: 'RadioButtonCardGroups',
        name: 'Radio Button Card Groups',
        meta: { showComponentPreview: false },
        component: () =>
          import(
            /* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryRadioButtonCardGroupsPage.vue'
          ),
      },
      {
        path: 'Tooltips',
        name: 'Tooltips',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryTooltipsPage.vue'),
      },
      {
        path: 'Snippets',
        name: 'Snippets',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibrarySnippetsPage.vue'),
      },
      {
        path: 'TextArea',
        name: 'Text Area',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryTextArea.vue'),
      },
      {
        path: 'TextBox',
        name: 'Text Box',
        meta: { showComponentPreview: false },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryTextBox.vue'),
      },
      {
        path: 'Toast',
        name: 'Toast',
        meta: { showComponentPreview: true },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/uiLibrary/UiLibraryToastPage.vue'),
      },
    ],
  },
];

export default uiLibraryRoutes;
